// extracted by mini-css-extract-plugin
module.exports = {"toggle":"styles_toggle__1jpap","pill":"styles_pill__1_YD5","header":"styles_header__1JMU6"};